import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import './Dining.scss';
import { useHistory } from 'react-router-dom';
import DiningOptions from '../diningOptions/DiningOptions';
import { breakfastType, dinnerType } from '../../utils';
import { virtualPageView } from '../../googleTagManager';

const getBookedSlotsOfThisEvent = ({ Addon = {} }) => (!Addon.code ? [] : [Addon.code]);
const handleSaveAddon = async (
  bookedAddonCodes = [],
  previouslyBookedAddonCode = '',
  filteredOptions = [],
  saveAddon = () => { },
  resId = 0,
  history,
  redirectPath,
  action = 'book',
) => {
  const [bookedAddon = {}] = bookedAddonCodes;
  const { slotId: bookedAddonCode } = bookedAddon;
  if (bookedAddonCode !== previouslyBookedAddonCode) {
    const addons = filteredOptions.map(({ code, type: addonType, startTime, endTime }) => ({
      code,
      quantity: code === bookedAddonCode ? 1 : 0,
      type: addonType === breakfastType ? 'breakfast' : 'dinner',
      startTime,
      endTime,
      previouslyBooked: code === previouslyBookedAddonCode,
    }));
    await saveAddon(resId, addons, action, previouslyBookedAddonCode !== '');
  }
  if (bookedAddonCode) {
    history.push(redirectPath);
  }
};

const Dining = ({
  title = 'Setup your experience',
  subTitle = 'Breakfast time?',
  diningSlots = [],
  getAvailableAddons = () => { },
  type = breakfastType,
  separatorLabel = 'Dining room closed for deep clean',
  resId = 0,
  saveAddon = () => { },
  redirectPath = '',
  bookedAddon = {},
  shouldFetchAvailableAddons,
  shouldSkip,
  optionsTitle,
  refreshTimeInterval,
  lastConfigCheckDateTime,
}) => {
  const history = useHistory();

  useEffect(() => {
    if (shouldFetchAvailableAddons) getAvailableAddons(resId);
  }, [getAvailableAddons, resId, shouldFetchAvailableAddons]);

  useEffect(() => {
    if (shouldSkip) history.push(redirectPath);
  }, [shouldSkip, history, redirectPath]);

  useEffect(() => {
    const diningType = type === breakfastType ? 'breakfast' : 'dinner';
    virtualPageView('plan my day', 'book mealtimes', `/ga-virtual/plan-my-day/book-mealtimes/${diningType}`);
  }, [type]);

  const filteredOptions = diningSlots.filter(option => option.type === type);
  const bookedAddonCode = bookedAddon && bookedAddon.Addon && bookedAddon.Addon.code;

  return (
    <div className="dining-main">
      <div className="titles">
        <div className="title">{title}</div>
        <div className="sub-title">{subTitle}</div>
      </div>
      <DiningOptions
        title={optionsTitle}
        separatorLabel={separatorLabel}
        options={filteredOptions && filteredOptions.length > 0 ? filteredOptions : []}
        saveAddon={newBookedAddon => handleSaveAddon(
          newBookedAddon,
          bookedAddonCode,
          filteredOptions,
          saveAddon,
          resId,
          history,
          redirectPath,
          'book',
        )}
        removeAddon={() => handleSaveAddon([], bookedAddonCode, filteredOptions, saveAddon, resId, history, redirectPath, 'cancel')}
        bookedSlotsOfThisEvent={getBookedSlotsOfThisEvent(bookedAddon)}
        refreshTimeInterval={refreshTimeInterval}
        lastConfigCheckDateTime={lastConfigCheckDateTime}
      />
    </div>
  );
};

Dining.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  diningSlots: PropTypes.array.isRequired,
  type: PropTypes.oneOf([breakfastType, dinnerType]).isRequired,
  separatorLabel: PropTypes.string,
  resId: PropTypes.number.isRequired,
  getAvailableAddons: PropTypes.func.isRequired,
  redirectPath: PropTypes.string.isRequired,
  saveAddon: PropTypes.func.isRequired,
  bookedAddon: PropTypes.object,
  shouldFetchAvailableAddons: PropTypes.bool.isRequired,
  shouldSkip: PropTypes.bool.isRequired,
  optionsTitle: PropTypes.string.isRequired,
  refreshTimeInterval: PropTypes.number,
  lastConfigCheckDateTime: PropTypes.string,
};

export default Dining;
